import { render, staticRenderFns } from "./OmzetPrint_Company.vue?vue&type=template&id=2fa33e7d&"
import script from "./OmzetPrint_Company.vue?vue&type=script&lang=js&"
export * from "./OmzetPrint_Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports